import React, { useState } from 'react';
import { apiService } from '../../services/api';
import { useMutation } from '../../hooks/useApi';
import logger from '../../utils/logger';
import { useSettings } from '../../context/SettingsContext';
import { Eye, FileDown } from 'lucide-react';

function RaportKrahasimProdukte() {
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [search, setSearch] = useState('');
  const [data, setData] = useState({});
  const [error, setError] = useState('');

  const { mutate: fetchRaport, loading: loadingRaport } = useMutation(
    async ({ search }) => {
      return await apiService.get('/raport-krahasim-produkte', { params: { search } });
    },
    {
      onSuccess: (data) => {
        setData(data?.data || {});
        setError('');
      },
      onError: () => {
        setError('Nuk mund te merret raporti i krahasimit.');
      },
      showNotifications: false
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    fetchRaport({ search });
  };

  const handleExportPdf = async () => {
    try {
      const response = await apiService.get('/raport-krahasim-produkte/pdf', {
        params: { search },
        responseType: 'blob'
      });
      const file = new Blob([response], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (err) {
      logger.error('PDF export error:', err);
      setError('Deshtoi shkarkimi i PDF-it.');
    }
  };

  const kaRezultate = Object.keys(data).length > 0;

  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          ⚖️
        </div>
        Raport Krahasim Produkte
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <label className="form-label">Kerko me emer produkti (opsionale)</label>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="input-premium"
            placeholder="p.sh. Atlete"
          />
        </div>
        <button
          type="submit"
          className="btn-primary mt-auto"
        >
          <Eye size={18} /> Shfaq
        </button>
      </form>

      {error && <p className="form-error text-center">{error}</p>}

      {loadingRaport && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent"></div>
        </div>
      )}

      {kaRezultate ? (
        <div className="space-y-8">
          <button
            onClick={handleExportPdf}
            className="btn-primary"
          >
            <FileDown size={18} /> Shkarko PDF
          </button>

          {Object.entries(data).map(([produkti, lista]) => (
            <div key={produkti} className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">Produkti: {produkti}</h3>

              <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 dark:border-dark-700 shadow">
                <table className="table-premium">
                  <thead>
                    <tr>
                      <th className="p-3 text-left">Furnizuesi</th>
                      <th className="p-3 text-left">Kodi</th>
                      <th className="p-3 text-right">Cmimi Blerjes</th>
                      <th className="p-3 text-right">Cmimi Shitjes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lista.map((item, index) => (
                      <tr key={index} className="border-t border-gray-200 dark:border-dark-700 hover:bg-gray-50 dark:hover:bg-dark-700/50">
                        <td className="p-3 text-gray-700 dark:text-gray-300">{item.furnizuesi || '-'}</td>
                        <td className="p-3 text-gray-700 dark:text-gray-300">{item.kodi || '-'}</td>
                        <td className="p-3 text-right text-gray-700 dark:text-gray-300">{Number(item.cmimi_blerjes).toFixed(2)} {currencyCode}</td>
                        <td className="p-3 text-right font-semibold text-primary-600 dark:text-primary-400">{Number(item.cmimi_shitjes).toFixed(2)} {currencyCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="md:hidden space-y-4">
                {lista.map((item, index) => (
                  <div key={index} className="card-premium p-4 space-y-1">
                    <div className="text-gray-700 dark:text-gray-300"><strong>Furnizuesi:</strong> {item.furnizuesi || '-'}</div>
                    <div className="text-gray-700 dark:text-gray-300"><strong>Kodi:</strong> {item.kodi || '-'}</div>
                    <div className="text-gray-700 dark:text-gray-300"><strong>Cmimi Blerjes:</strong> {Number(item.cmimi_blerjes).toFixed(2)} {currencyCode}</div>
                    <div className="text-gray-700 dark:text-gray-300"><strong>Cmimi Shitjes:</strong> <span className="font-semibold text-primary-600 dark:text-primary-400">{Number(item.cmimi_shitjes).toFixed(2)} {currencyCode}</span></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        !loadingRaport && (
          <div className="empty-state">
            <p className="empty-state-title">Nuk ka produkte për krahasim</p>
            <p className="empty-state-description">Nuk ka produkte me emër të njëjtë për krahasim.</p>
          </div>
        )
      )}
    </div>
  );
}

export default RaportKrahasimProdukte;
